import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  Spin,
  Tag,
  Row,
  Col,
  Button,
  Icon,
  Empty,
  Dropdown,
  Menu,
  Popconfirm,
} from "antd";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import moment from "moment";
import { Translation } from "react-i18next";
import i18next from "i18next";
import ar from "antd/es/date-picker/locale/ar_EG";
import en from "antd/es/date-picker/locale/en_US";
import { MenuItem } from "@material-ui/core";
import { convertTZToLocalCDR } from "../general/DateTzHelper";
import { CloseCircleOutlined, SyncOutlined } from "@ant-design/icons";
import "./ListInvitations.css";
import { invitationService } from "../../services/invitation/InvitationService";
import { showSuccessToast } from "../general/ToastHelper";
import FilterablePaginatedTable from "../general/FilterablePaginatedTable";
import { UserService } from "../../services/user/UserService";
import UserDetailsDialog from "../user/UserDetailsDialog";

function ListInvitations(props) {
  moment.locale("en");
  const sessionId = props.context.session_id;
  const privilegesList = props.context.user.privilegesList;
  const userService = new UserService();

  const [lang, setLang] = useState(
    props.context.curr_lang === "ar" && props.context.curr_dir === "rtl"
      ? "ar"
      : "en"
  );
  let [isFetching, setIsFetching] = useState(false);
  let [invitations, setInvitations] = useState([]);
  let [total, setTotal] = useState(0);

  let [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [isFetchingUser, setIsFetchingUser] = useState(false);

  useEffect(() => {
    if (!tableParams) {
      return;
    }
    let pageData = {
      pagination: {
        page: tableParams.pagination.current,
        size: tableParams.pagination.pageSize,
      },
      filters: tableParams.filters,
    };
    getInvitations(pageData);
  }, [tableParams]);

  const getInvitations = async (pageData) => {
    try {
      setIsFetching(true);
      let data = await invitationService.getPaginatedInvitationsByAccount(
        sessionId,
        pageData.pagination.page,
        pageData.pagination.size,
        pageData.filters?.invitationStatus || null
      );
      setInvitations(data.ivrList);
      setTotal(data.totalRecords);
      setIsFetching(false);

    } catch (e) {
      setIsFetching(false);
      handleError(e);
    }
  };

  const columns = [
    {
      title: i18next.t("User Name"),
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: i18next.t("User Type"),
      dataIndex: "userType",
      key: "userType",
      render: (userType) => i18next.t(userType)
    },
    {
      title: i18next.t("Status"),
      dataIndex: "invitationStatus",
      key: "invitationStatus",
      render: (_, { invitationStatus }) => {
        return (
          <Row>
            {invitationStatus === "PENDING" ? (
              <Tag className="invitation-status-tag" color="gold">
                {i18next.t(invitationStatus)}
              </Tag>
            ) : invitationStatus === "ACCEPTED" ? (
              <Tag className="invitation-status-tag" color="green">
                {i18next.t(invitationStatus)}
              </Tag>
            ) : invitationStatus === "REJECTED" ? (
              <Tag className="invitation-status-tag" color="red">
                {i18next.t(invitationStatus)}
              </Tag>
            ) : invitationStatus === "CANCELLED" ? (
              <Tag className="invitation-status-tag" color="red">
                {i18next.t(invitationStatus)}
              </Tag>
            ) : invitationStatus === "EXPIRED" ? (
              <Tag className="invitation-status-tag" color="orange">
                {i18next.t(invitationStatus)}
              </Tag>
            ) : null}
          </Row>
        );
      },
    },
    {
      title: i18next.t("Expires On"),
      dataIndex: "expiresAt",
      key: "expiresAt",
      render: (value) => convertTZToLocalCDR(value),
    },

    {
      title: i18next.t("Action"),
      dataIndex: "operation",
      render: (text, record) => renderActionDropdown(record),
    },
  ];
  const renderActionDropdown = (record) => {
    const menu = (
      <Menu>
        <Menu.Item
          style={{
            display:
              (record.invitationStatus === "PENDING" || record.invitationStatus === "EXPIRED") &&
              privilegesList.includes("RESEND.INVITATION")
                ? "block"
                : "none",
          }}
        >
          <Popconfirm
            title={i18next.t(
              "Are you sure you want to resend this invitation?"
            )}
            onConfirm={() => resendInvitation(record.userId)}
            okText={i18next.t("Yes")}
            cancelText={i18next.t("No")}
          >
            <a href="#" style={{ color: "rgba(0, 0, 0, 0.65)" }}>
              {i18next.t("Resend")}{" "}
              <SyncOutlined className={"view-details-style"} />
            </a>
          </Popconfirm>
        </Menu.Item>

        <Menu.Item
          style={{
            display:
              (record.invitationStatus === "PENDING" || record.invitationStatus === "EXPIRED") &&
              privilegesList.includes("CANCEL.INVITATION")
                ? "block"
                : "none",
          }}
        >
          <Popconfirm
            title={i18next.t(
              "Are you sure you want to cancel this invitation?"
            )}
            onConfirm={() => cancelInvitaion(record.userId)}
            okText={i18next.t("Yes")}
            cancelText={i18next.t("No")}
          >
            <a href="#" style={{ color: "rgba(0, 0, 0, 0.65)" }}>
              {i18next.t("Cancel")}{" "}
              <CloseCircleOutlined className={"view-details-style"} />
            </a>
          </Popconfirm>
        </Menu.Item>
        <Menu.Item onClick={() => getUserData(record?.userId, record?.userType, record?.invitationStatus)}>
          <span>{i18next.t("View Details")}</span>
          <Icon className={"view-details-style"} type="eye" />
        </Menu.Item>
      </Menu>
    );

    return (
      <Dropdown overlay={menu}>
        <Button size="small" style={{ borderWidth: 0 }}>
          <Icon item={record} type="more" />
        </Button>
      </Dropdown>
    );
  };

  const cancelInvitaion = async (userId) => {
    setIsFetching(true);
    try {
      let requestData = {
        userId: userId,
        invitationId: null,
      };
      let data = await invitationService.cancelInvitation(
        sessionId,
        requestData
      );
      setIsFetching(false);
      showSuccessToast(i18next.t("Invitation has been canceled successfully"));
      handleRefresh();
    } catch (e) {
      setIsFetching(false);
      handleError(e);
    }
  };
  const resendInvitation = async (userId) => {
    setIsFetching(true);
    try {
      let data = await invitationService.resendInvitation(sessionId, userId);
      showSuccessToast(i18next.t("Invitation has been resent successfully"));
      setIsFetching(false);
      handleRefresh();
    } catch (e) {
      setIsFetching(false);
      handleError(e);
    }
  };
  const handleRefresh = () => {
    let pageRequest = {
        pagination: {
          page: tableParams.pagination.current,
          size: tableParams.pagination.pageSize
        },
        filters: tableParams.filters
      };
    getInvitations(pageRequest)
  };

  const getUserData = async (userId, type, invStatus) => {
    setSelectedUser(null);
    setIsModalVisible(true);
    setIsFetchingUser(true);
    try {
      let userData = await userService.getUserByIdService(sessionId, userId);
      setSelectedUser({... userData?.ivrCustomEntityObject, userType: type, 
        userStatus: userData?.ivrCustomEntityObject?.cfg?.find(item => item?.AGENT_STATUS)?.AGENT_STATUS, invitationStatus:invStatus});
      setIsFetchingUser(false);
    } catch (error) {
      setIsFetchingUser(false);
      handleError(error);
    }
  };
  return (
    <>
      <Translation>
        {(t) => (
          <Page title={t("Invitations")}>
            <div>
              <FilterablePaginatedTable
                dataSource={invitations}
                rowKey="invitationId"
                total={total}
                columns={columns}
                loading={isFetching}
                tableParams={tableParams}
                onTableParamsChange={setTableParams}
                // filterableColumns={'invitationStatus'}
              />
            </div>
          </Page>
        )}
      </Translation>
      <UserDetailsDialog
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        user={selectedUser}
        loading={isFetchingUser}
      />
    </>
  );
}
export default withSharedStateConsumer(ListInvitations);
